export const LANG_XX_NAME = "xx";

export const LANG_XX_TRANS = {
	"download.button" : "xDownload",
	// tslint:disable-next-line:max-line-length
	"download.configuration.message" : "xAfter xyour xvirtual xappliance xhas xbeen xsuccessfully xinstalled, xsetup xwill xcontinue ixn xthe xvirtual xmachine xconsole",
	"download.info.block.1" : "xClick",
	"download.info.block.2" : "xhere",
	"download.info.block.3" : "xto xview xthe xinstallation xdocumentation",
	"download.info.block.4" : "xFor xassistance, xcontact xsupport:",
	"download.info.title" : "xDownload SafeConnect",
	"download.media.version" : "xVersion",
	"download.media.size" : "xSize",
	"download.media.unselected" : "xPlease xselect xthe xmedia xfor xyour xinstallation.",
	"download.statusMessage.404" : "xThere xwas xan xerror xdownloading xyour xfile, xplease xcontact xsupport xfor xhelp.",
	"download.statusMessage.200" : "xYour xfile xdownload xhas xstarted.",
	"footer.rights" : "xALL xRIGHTS xRESERVED",
	"header.sub.title" : "xCloud xPortal"
}
